<template>
  <div>
    <button class="reset-button" @click="resetAll()">
      <svg
        id="Layer_1"
        width="18"
        height="18"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 118.04 122.88"
      >
        <path
          style="fill: rgb(0, 0, 0)"
          d="M16.08,59.26A8,8,0,0,1,0,59.26a59,59,0,0,1,97.13-45V8a8,8,0,1,1,16.08,0V33.35a8,8,0,0,1-8,8L80.82,43.62a8,8,0,1,1-1.44-15.95l8-.73A43,43,0,0,0,16.08,59.26Zm22.77,19.6a8,8,0,0,1,1.44,16l-10.08.91A42.95,42.95,0,0,0,102,63.86a8,8,0,0,1,16.08,0A59,59,0,0,1,22.3,110v4.18a8,8,0,0,1-16.08,0V89.14h0a8,8,0,0,1,7.29-8l25.31-2.3Z"
        />
      </svg>
    </button>
    <div class="tabs">
      <div class="tab" @click="selectDistance(5, 0)"><strong>5</strong>km</div>
      <div class="tab" @click="selectDistance(10, 1)">
        <strong>10</strong>km
      </div>
      <div class="tab" @click="selectDistance(21.097, 2)">
        <strong>하프</strong>
      </div>
      <div class="tab" @click="selectDistance(42.195, 3)">
        <strong>풀코스</strong>
      </div>
      <div class="tab" @click="selectDistance('etc', 4)">
        <strong>etc.</strong>
      </div>
    </div>
    <div class="calcul">
      <div class="etc-div" style="display: none">
        <strong class="tit-unit">이외거리</strong>
        <ul>
          <li>
            <button class="etcBtn" @click="selectDistanceEtc(1)">
              <strong>1</strong>km
            </button>
          </li>
          <li>
            <button class="etcBtn" @click="selectDistanceEtc(2)">
              <strong>2</strong>km
            </button>
          </li>
          <li>
            <button class="etcBtn" @click="selectDistanceEtc(3)">
              <strong>3</strong>km
            </button>
          </li>
          <li>
            <button class="etcBtn" @click="selectDistanceEtc(30)">
              <strong>30</strong>km
            </button>
          </li>
          <li>
            <button class="etcBtn" @click="selectDistanceEtc(32)">
              <strong>32</strong>km
            </button>
          </li>
        </ul>
        
        <div class="distanceInput">
          <strong class="tit-unit">수동거리</strong>
          <ul>
            <li class="select">
              <select name="" id="etcSelect" @change="etcSelectChange()">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
                <option value="32">32</option>
                <option value="33">33</option>
                <option value="34">34</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
                <option value="41">41</option>
                <option value="42">42</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </li>
            <li>.</li>
            <li class="select">
              <select name="" id="etcSelect1" @change="etcSelectChange()" :disabled="isTimeSelectDisabled">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
              </select>
            </li>
            <li><span>km</span></li>
          </ul>
        </div>
      </div>
      <!-- //etc-div -->
      <div class="special-buttonsWrap" style="display: none;">
        <strong class="tit-unit">자동계산</strong>
        <div class="special-buttons">
          <div class="special-button" @click="setSpecialDistance('40분 언더')">
            40분 언더
          </div>
          <div class="special-button" @click="setSpecialDistance('싱글')">
            싱글
          </div>
          <div class="special-button" @click="setSpecialDistance('섭3')">섭3</div>
        </div>
      </div>
      <div class="time-inputs disabled">
        <strong class="tit-unit">수동계산</strong>
        <div class="time-inputs-div">
          <select id="hours" disabled @change="activateCalculateButton()">
            <option value="0">0시간</option>
            <option value="1">1시간</option>
            <option value="2">2시간</option>
            <option value="3">3시간</option>
            <option value="4">4시간</option>
            <option value="5">5시간</option>
          </select>
        </div>
        <div class="time-inputs-div">
          <select
            id="minutes"
            disabled
            @change="activateCalculateButton()"
          ></select>
        </div>
        <div class="time-inputs-div">
          <select
            id="seconds"
            disabled
            @change="activateCalculateButton()"
          ></select>
        </div>
      </div>

      <div class="calcul-bottom">
        <div class="calcul-bottom-history">
          <ul id="historyList"></ul>
        </div>
        <button id="calculateButton" disabled @click="calculatePace()">
          계산
        </button>
      </div>
    </div>
    <div class="goal-div" style="display: none">
      <h3>필요한 페이스</h3>
      <ul>
        <li id="perHour"></li>
        <li id="pace400"></li>
        <li id="pace"></li>
      </ul>
    </div>
  </div>
</template>
  
<script>
let selectedDistance = null;
// 검색 히스토리 저장 및 관리
export default {
  name: "PaceCalculator",
  mounted() {
    this.initializeApp();
    this.populateTimeSelects();
    this.renderHistory();
    this.doubleTapBlock();
  },
  methods: {
    initializeApp() {
      console.log("Vue has initialized!");
      // 초기화 코드 작성
    },
    doubleTapBlock() {
      document.documentElement.addEventListener(
        "touchstart",
        function (event) {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        },
        false
      );

      var lastTouchEnd = 0;

      document.documentElement.addEventListener(
        "touchend",
        function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
    },
    populateTimeSelects() {
      const minutesSelect = document.getElementById("minutes");
      const secondsSelect = document.getElementById("seconds");

      for (let i = 0; i < 60; i++) {
        const minuteOption = document.createElement("option");
        minuteOption.value = i;
        minuteOption.textContent = `${i}분`;
        minutesSelect.appendChild(minuteOption);

        const secondOption = document.createElement("option");
        secondOption.value = i;
        secondOption.textContent = `${i}초`;
        secondsSelect.appendChild(secondOption);
      }
    },
    selectDistance(km, index) {
      //if (isSpecialTabSelected) return;
      this.resetAll();
      selectedDistance = Number(km);

      const tabs = document.querySelector(".tabs"); // 탭 컨테이너
      const allTabs = tabs.children; // 모든 탭 버튼

      // 모든 탭에서 active 클래스를 제거
      Array.from(allTabs).forEach((tab) => tab.classList.remove("active"));

      // 선택된 index의 탭에 active 클래스 추가
      if (index !== undefined && allTabs[index]) {
        allTabs[index].classList.add("active");
      }
      // etc-div 처리
      const etcDiv = document.querySelector(".etc-div");
      const btnWrap = document.querySelector(".special-buttonsWrap");
      // const btn = document.querySelector(".special-buttons");
      if (
        selectedDistance === 5 ||
        selectedDistance === 10 ||
        selectedDistance === 21.097 ||
        selectedDistance === 42.195
      ) {
        etcDiv.style.display = "none"; // 다른 탭 클릭 시 숨김
        btnWrap.style.display = "block";
        this.enableTimeInputs(false);
      } else {
        etcDiv.style.display = "block"; // etc. 클릭 시 표시
        btnWrap.style.display = "none";
        this.enableTimeInputs(true);
      }

      // 자동계산 버튼 설정
      this.configureSpecialButtons(km);
    },
    selectDistanceEtc(km) {
      selectedDistance = km;
      document.querySelectorAll(".etcBtn").forEach((tab) => tab.classList.remove("active"));
      event.target.classList.add("active");
      this.enableTimeInputs(false);
      document.querySelector("#etcSelect").value = selectedDistance;
    },
    etcSelectChange() {
      // 첫 번째 select의 값 (정수 부분)
      const integerPart = document.querySelector("#etcSelect").value;

      // 두 번째 select의 값 (소수점 부분)
      const decimalPart = document.querySelector("#etcSelect1").value;

      // 정수와 소수점 부분을 결합하여 selectedDistance 설정
      selectedDistance = parseFloat(`${integerPart}.${decimalPart}`);

      // 기존 버튼의 active 상태 해제
      document
        .querySelectorAll(".etcBtn")
        .forEach((tab) => tab.classList.remove("active"));

      // 시간 입력 필드 활성화 비활성화
      this.enableTimeInputs(false);

      // console.log("Selected distance:", selectedDistance); // 확인용 로그
    },
    configureSpecialButtons(km) {
      const specialButtonsContainer =
        document.querySelector(".special-buttons");
      specialButtonsContainer.innerHTML = ""; // 기존 버튼 초기화

      const buttonOptions = this.getButtonOptions(Number(km));
      //console.log(buttonOptions, km)
      buttonOptions.forEach((option) => {
        const button = document.createElement("div");
        button.className = "special-button";
        button.innerHTML = option.label;
        button.onclick = () => this.setHoursMinutesSeconds(...option.time);
        specialButtonsContainer.appendChild(button);
      });
    },
    getButtonOptions(km) {
      switch (km) {
        case 5:
          return [
            {
              label: '17’↓<span class="subs">번개 스프린터</span>',
              time: [0, 16, 59],
            },
            {
              label: '19’↓<span class="subs">신세계 입성</span>',
              time: [0, 18, 59],
            },
            {
              label: '20’↓<span class="subs">고통러너</span>',
              time: [0, 19, 59],
            },
            {
              label: '25’↓<span class="subs">미들러너</span>',
              time: [0, 24, 59],
            },
            {
              label: '30’↓<span class="subs">꾸준히 챔피언</span>',
              time: [0, 29, 59],
            },
            {
              label: '35’↓<span class="subs">즐거운 러너</span>',
              time: [0, 34, 59],
            },
          ];
        case 10:
          return [
            {
              label: '36’↓<span class="subs">전국구 러너</span>',
              time: [0, 35, 59],
            },
            {
              label: '40’↓<span class="subs">신세계 입성</span>',
              time: [0, 39, 59],
            },
            {
              label: '43’↓<span class="subs">고통러너</span>',
              time: [0, 42, 59],
            },
            {
              label: '45’↓<span class="subs">중급러너</span>',
              time: [0, 44, 59],
            },
            {
              label: '50’↓<span class="subs">초보러너</span>',
              time: [0, 49, 59],
            },
            {
              label: '1h↓<span class="subs">조기축구남</span>',
              time: [0, 59, 59],
            },
          ];
        case 21.097:
          return [
            {
              label: '1h20’↓<span class="subs">하프 킹</span>',
              time: [1, 19, 59],
            },
            {
              label: '1h25’↓<span class="subs">가자 섭3</span>',
              time: [1, 24, 59],
            },
            {
              label: '1h30’↓<span class="subs">지구력 마스터</span>',
              time: [1, 29, 59],
            },
            {
              label: '1h45’↓<span class="subs">꾸준함의 아이콘</span>',
              time: [1, 44, 59],
            },
            {
              label: '2h00’↓<span class="subs">러닝 철학자</span>',
              time: [1, 59, 59],
            },
            {
              label: '2h15’↓<span class="subs">입문러너</span>',
              time: [2, 14, 59],
            },
          ];
        case 42.195:
          return [
            {
              label: '2h49’↓<span class="subs">249러너</span>',
              time: [2, 49, 59],
            },
            { label: '3h↓<span class="subs">섭3</span>', time: [2, 59, 59] },
            { label: '3h09’↓<span class="subs">싱글</span>', time: [3, 9, 59] },
            {
              label: '3h30’↓<span class="subs">고통러너</span>',
              time: [3, 29, 59],
            },
            { label: '4h↓<span class="subs">섭4</span>', time: [3, 59, 59] },
            {
              label: '4h20’↓<span class="subs">입문러너</span>',
              time: [4, 19, 59],
            },
          ];
        default:
          return [];
      }
    },
    setHoursMinutesSeconds(hours, minutes, seconds) {
      document.getElementById("hours").value = hours;
      document.getElementById("minutes").value = minutes;
      document.getElementById("seconds").value = seconds;
      this.activateCalculateButton();
      this.calculatePace();
    },
    activateCalculateButton() {
      const hours = document.getElementById("hours").value;
      const minutes = document.getElementById("minutes").value;
      const seconds = document.getElementById("seconds").value;
      document.getElementById("calculateButton").disabled = !(
        hours > 0 ||
        minutes > 0 ||
        seconds > 0
      );
    },
    enableTimeInputs(isDisabled) {
      ["hours", "minutes", "seconds"].forEach(
        (id) => (document.getElementById(id).disabled = isDisabled)
      );
      document.querySelector(".time-inputs").classList.toggle("disabled", isDisabled);
    },
    saveToHistory(distance) {
      const hours = parseInt(document.getElementById("hours").value);
      const minutes = parseInt(document.getElementById("minutes").value);
      const seconds = parseInt(document.getElementById("seconds").value);
      const totalTime = this.formatTime(hours * 3600 + minutes * 60 + seconds); // 전체 시간 계산

      const historyItem = { distance, time: totalTime };

      // 로컬스토리지에서 기존 히스토리를 가져오기
      let history = JSON.parse(localStorage.getItem("history")) || [];

      // 새 항목 추가 및 최대 10개로 제한
      history.unshift(historyItem);
      if (history.length > 10) {
        history.pop();
      }

      // 로컬스토리지에 업데이트
      localStorage.setItem("history", JSON.stringify(history));

      //renderHistory();
    },
    renderHistory() {
      // calcul-bottom 컨테이너 가져오기
      const calculBottom = document.querySelector(".calcul-bottom");
      if (!calculBottom) {
        console.error("Element with class 'calcul-bottom' not found.");
        return;
      }

      let history = JSON.parse(localStorage.getItem("history")) || [];

      // 중복 제거: distance와 time을 기준으로 고유한 항목만 남김
      const uniqueHistory = [];
      const seen = new Set();
      history.forEach(({ distance, time }) => {
        const key = `${distance}-${time}`;
        if (!seen.has(key)) {
          seen.add(key);
          uniqueHistory.push({ distance, time });
        }
      });

      // 기존 calcul-bottom-history 제거 (중복 추가 방지)
      const existingHistoryDiv = document.querySelector(
        ".calcul-bottom-history"
      );
      if (existingHistoryDiv) {
        existingHistoryDiv.remove();
      }

      // 만약 히스토리가 비어있다면 아무것도 추가하지 않음
      if (uniqueHistory.length === 0) return;

      // calcul-bottom-history 동적으로 생성
      const historyDiv = document.createElement("div");
      historyDiv.classList.add("calcul-bottom-history");

      // 히스토리 리스트 생성
      const historyList = document.createElement("ul");
      historyList.id = "historyList";

      // 히스토리 버튼 생성
      uniqueHistory.forEach(({ distance, time }) => {
        const listItem = document.createElement("li");

        const button = document.createElement("button");
        const distanceLabel = this.formatDistance(distance); // 거리 텍스트 형식화
        //console.log(distanceLabel)
        button.setAttribute("data-distance", distance);
        button.innerHTML = `<strong>${distanceLabel}</strong> ${time}`;
        button.addEventListener("click", () => {
          const distanceValue = button.getAttribute("data-distance");
          selectedDistance = Number(distanceValue);

          // selectDistance 호출
          const predefinedDistances = [5, 10, 21.097, 42.195];
          const num = predefinedDistances.includes(Number(distanceValue))
            ? predefinedDistances.indexOf(Number(distanceValue))
            : 4;
          this.selectDistance(distanceValue, num);

          // `#etcSelect` 값을 업데이트
          const etcSelect = document.getElementById("etcSelect");
          const etcSelect1 = document.getElementById("etcSelect1");
          if (num === 4) {
            const [integerPart, decimalPart] = distanceValue.split(".");
            // console.log(integerPart, decimalPart)
            // 자연수 부분 설정
            etcSelect.value = integerPart || "0";
            // 소수점 부분 설정 (없으면 초기화)
            etcSelect1.value = decimalPart || "0";
          } else {
            etcSelect.value = "";
            etcSelect1.value = "";
          }

          // 시간 설정
          const [hours, minutes, seconds] = this.parseTimes(time)[0];
          this.setHoursMinutesSeconds(hours, minutes, seconds);
          this.enableTimeInputs(false);
        });

        listItem.appendChild(button);
        historyList.appendChild(listItem);
      });

      // 히스토리 리스트를 calcul-bottom-history에 추가
      historyDiv.appendChild(historyList);

      // calcul-bottom에 calcul-bottom-history 추가
      calculBottom.insertBefore(historyDiv, calculBottom.firstChild);
    },
    formatDistance(distance) {
      // 21.097은 하프, 42.195는 풀로 변환
      if (
        distance === 21.097 ||
        distance === "21.097km" ||
        distance === "21.097"
      ) {
        return "하프";
      } else if (
        distance === 42.195 ||
        distance === "42.195km" ||
        distance === "42.195"
      ) {
        return "풀";
      }
      return `${distance}km`; // 기본 km 단위
    },
    parseTimes(timeStrings) {
      // timeStrings가 배열이 아니면 배열로 변환
      if (!Array.isArray(timeStrings)) {
        timeStrings = [timeStrings];
      }

      const result = [];

      // 각 시간 문자열을 처리
      timeStrings.forEach((timeString) => {
        // 시간, 분, 초를 캡처하는 정규식 (다양한 따옴표와 기호 지원)
        const timeRegex = /(?:(\d+)h)?(?:(\d+)[‘’'])?(?:(\d+)[“”"])?/;
        const match = timeString.match(timeRegex);

        if (!match) {
          console.error("Invalid time format:", timeString);
          result.push([0, 0, 0]); // 기본값 설정
          return;
        }

        // 캡처된 값 추출 및 기본값 설정
        const hours = match[1] ? parseInt(match[1]) : 0; // 시간 없으면 0
        const minutes = match[2] ? parseInt(match[2]) : 0; // 분 없으면 0
        const seconds = match[3] ? parseInt(match[3]) : 0; // 초 없으면 0

        result.push([hours, minutes, seconds]);
      });

      return result;
    },
    resetAll() {
      selectedDistance = null;
      document
        .querySelectorAll(".tab, .special-button")
        .forEach((tab) => tab.classList.remove("active", "disabled"));
      // document.querySelector(".special-buttons").style.display = "none"; // 리셋 시 자동계산 영역 숨김
      document.querySelector(".etc-div").style.display = "none";

      document.getElementById("hours").value = 0;
      document.getElementById("minutes").value = 0;
      document.getElementById("seconds").value = 0;
      document.querySelector("#etcSelect").value = 0;
      document.querySelector("#etcSelect1").value = 0;
      document.getElementById("calculateButton").disabled = true;
      document.getElementById("pace").textContent = "";
      document.getElementById("pace400").textContent = "";
      // document.getElementById("subDistancePace").textContent = '';
      document.querySelector(".goal-div").style.display = "none";
      document.querySelector(".special-buttonsWrap").style.display = "none";
      document
        .querySelectorAll(".etcBtn")
        .forEach((tab) => tab.classList.remove("active"));
      this.enableTimeInputs(true);

      // 히스토리는 초기화하지 않음
    },
    calculatePace() {
      document.querySelector(".goal-div").style.display = "block";
      const hours = parseInt(document.getElementById("hours").value);
      const minutes = parseInt(document.getElementById("minutes").value);
      const seconds = parseInt(document.getElementById("seconds").value);

      if (!selectedDistance) return;

      const totalSeconds = hours * 3600 + minutes * 60 + seconds;
      if (totalSeconds === 0) {
        document.getElementById("pace").innerHTML =
          "페이스: <span style='color:red;'>값을 다시 입력해주세요.</span>";
        return;
      }

      const pacePerKm = totalSeconds / selectedDistance;
      const paceMinutes = Math.floor(pacePerKm / 60);
      const paceSeconds = Math.floor(pacePerKm % 60);
      const pacePer400m = pacePerKm / 2.5;

      const pace400Seconds = Math.round(pacePer400m * 10) / 10;
      const formattedPaceSeconds = String(paceSeconds).padStart(2, "0");

      const perHourSpeed = (selectedDistance / (totalSeconds / 3600)).toFixed(
        1
      ); // 시속 계산
      const paceText = `${paceMinutes}’${formattedPaceSeconds}”`;
      const pace400Text = `${pace400Seconds}”`;

      document.getElementById(
        "perHour"
      ).innerHTML = `<span>시속</span><strong>${perHourSpeed} <i>km&#47;h</i></strong>`;
      document.getElementById(
        "pace400"
      ).innerHTML = `<span>400<i>m</i></span><strong>${pace400Text}</strong>`;
      document.getElementById(
        "pace"
      ).innerHTML = `<span>1<i>km</i></span><strong>${paceText}</strong>`;

      // subDistancePace 이후 형제로 동적으로 <li> 요소 추가
      const subDistancePace = document.getElementById("pace");
      let nextSibling = subDistancePace.nextElementSibling;

      // 이전에 추가된 형제 요소 초기화
      while (nextSibling && nextSibling.tagName === "LI") {
        const temp = nextSibling.nextElementSibling;
        nextSibling.remove();
        nextSibling = temp;
      }

      const addSubDistance = (distance, label) => {
        const time = this.formatTime(pacePerKm * distance);
        const newLi = document.createElement("li");
        newLi.innerHTML = `<span>${label}</span><strong>${time}</strong>`;
        subDistancePace.parentNode.insertBefore(
          newLi,
          subDistancePace.nextSibling
        );
      };
      if (selectedDistance > 21.097) {
        addSubDistance(21.097, "하프");
      }
      if (selectedDistance > 10) {
        addSubDistance(10, "10<i>km</i>");
      }
      if (selectedDistance > 5) {
        addSubDistance(5, "5<i>km</i>");
      }

      // 히스토리에 추가
      this.saveToHistory(selectedDistance);

      // 히스토리 UI 즉시 업데이트
      this.renderHistory();
    },
    calculateVO2Max() {
      const distance = parseFloat(document.getElementById("distance").value); // km
      const time = parseFloat(document.getElementById("time").value); // minutes

      if (!distance || !time || distance <= 0 || time <= 0) {
        document.getElementById("vo2maxResult").innerHTML =
          "<span style='color:red;'>거리와 시간을 올바르게 입력하세요.</span>";
        return;
      }

      // Cooper Test 공식 적용 (12분 기준)
      const distanceMeters = distance * 1000;
      const vo2Max = distanceMeters * 0.0225 - 11.3;

      document.getElementById(
        "vo2maxResult"
      ).innerHTML = `계산된 VO₂ Max: <b>${vo2Max.toFixed(2)} ml/kg/min</b>`;
    },
    calculatePaceFromVO2Max() {
      const distance = parseFloat(document.getElementById("distance").value);
      const time = parseFloat(document.getElementById("time").value);

      if (!distance || !time || distance <= 0 || time <= 0) {
        document.getElementById("vo2maxResult").innerHTML =
          "<span style='color:red;'>거리와 시간을 올바르게 입력하세요.</span>";
        return;
      }

      // VO₂ Max 계산
      const vo2Max = (distance / (time / 60)) * 28.38;

      // VO₂ Max를 기반으로 페이스 계산
      const K = 200; // VO₂와 속도 간 상수
      const pacePerKmSeconds = 60 / (((vo2Max - 3.5) * K) / 1000); // 초/km
      const paceMinutes = Math.floor(pacePerKmSeconds / 60);
      const paceSeconds = Math.round(pacePerKmSeconds % 60);

      document.getElementById(
        "vo2maxResult"
      ).innerHTML = `계산된 VO₂ Max: <b>${vo2Max.toFixed(
        2
      )}</b><br>예상 페이스: <b>${paceMinutes}’${String(paceSeconds).padStart(
        2,
        "0"
      )}”</b>`;
    },
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      // 분과 초를 항상 두 자리로 포맷
      const formattedMins = mins < 10 ? `0${mins}` : mins;
      const formattedSecs = secs < 10 ? `0${secs}` : secs;

      return hours > 0
        ? `${hours}h${formattedMins}’${formattedSecs}”`
        : `${formattedMins}'${formattedSecs}”`;
    },
  },
};
</script>
  

<style>
.reset-button {
  border: 0;
  background: 0;
  width: 32px;
  height: 32px;
  position: absolute;
  top: 10px;
  right: 48px;
}

.calcul-bottom-history {
  flex: 1;
  text-align: left;
  overflow-x: auto;
  position: relative;
  overflow-x: hidden;
}

.calcul-bottom-history:after {
  content: "";
  display: block;
  width: 1em;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(0.25turn, rgba(49, 94, 169, 0), #5b94eb);
  pointer-events: none;
}

.calcul-bottom-history > ul {
  display: flex;
  /* gap: .4em; */
  padding: 0.5em 0;
  width: 100%;
  overflow-x: auto;
}

.calcul-bottom-history > ul > li {
  margin-right: 0.4em;
}

.calcul-bottom-history > ul > li > button {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  height: 26px;
  border-radius: 13px;
  position: relative;
  padding-left: 29px;
  font-size: 12px;
  letter-spacing: -1px;
}

.calcul-bottom-history > ul > li > button > strong {
  display: inline-block;
  background-color: #fff;
  color: #669df3;
  height: 26px;
  line-height: 26px;
  border-radius: 13px;
  padding: 0;
  position: absolute;
  top: -1px;
  left: -1px;
  font-size: 9px;
  width: 25px;
  font-weight: bold;
  overflow: hidden;
}
.special-buttonsWrap{
  position: relative;
  margin-bottom: 25px;
}
.special-buttons {
  display: grid;
  /*처음에는 숨겨둠*/
  grid-template-columns: repeat(6, 1fr);
  gap: 2px;
  font-size: 1em;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 15px;
  position: relative;
  grid-template-columns: repeat(3, 1fr);
  height: 108px;
  position: relative;
}


.special-button {
  cursor: pointer;
  padding: 8px 16px;
  background-color: rgba(255, 255, 255, 0.3);
  color: #333;
  text-align: center;
}

.special-button {
  font-size: 1.1em;
  padding: 0.5em 0;
  gap: 0.2em;
  min-height: 2em;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 0.3em;
}

.special-button .subs {
  font-size: 0.75em;
  color: #fff;
  opacity: 0.7;
}

.tab.disabled,
.special-button.disabled {
  background-color: #d0d0d0;
  color: #aaa;
  cursor: not-allowed;
}

.special-button.active {
  background-color: #4caf50;
  color: white;
}

.tit-unit{
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0px 7px;
  background-color: #4881da;
  color: #fff;
  font-size: 0.7em;
}

.time-inputs {
  display: flex;
  justify-content: space-between;
  gap: 0.5em;
  /* margin-bottom: 25px; */
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  align-items: center;
}
.time-inputs.disabled{
  opacity: .3;
}

.no-line{
  padding-top: 0 !important;
  border-top: 0 !important;
  margin-top: 0 !important;
}

/* .time-inputs:before {
  content: "수동계산";
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0px 7px;
  background-color: #4881da;
  color: #fff;
  font-size: 0.7em;
} */

.time-inputs-div {
  flex: 1;
  position: relative;
}

.distanceInput > ul > li.select{
  position: relative;
}
.distanceInput > ul > li.select:before,
.time-inputs-div:before {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #fff;
  position: absolute;
  right: 0.4em;
  top: 50%;
  transform: translateY(-50%);
}
.time-inputs-div.disabled{
  opacity: 0.3;
}
.time-inputs-div.disabled:before {
  
}

.distanceInput > ul > li select,
.time-inputs-div select {
  font-size: 1.2em;
  padding: 0.1em 0.3em;
  width: 100%;
  height: 1.9em;
  color: #fff !important;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 0.5em;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-align: right;
  padding-right: 22px !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.time-inputs-text{
  flex: 1;
}
.time-inputs-text input{
  font-size: 1.2em;
  padding: 0.1em 0.5em;
  width: 100%;
  height: 36px;
  background-color: transparent !important;
  color: #fff !important;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 0.5em;
  box-sizing: border-box;
  text-align: right;
}




.distanceInput > ul > li > select::-ms-expand,
.time-inputs-div select::-ms-expand {
  display: none;
}

.distanceInput > ul > li > select:disabled,
.time-inputs-div select:disabled {
  background-color: #e0e0e0;
  color: #aaa;
  /* opacity: 0.3; */
}

select option {
  color: #000;
}

.etc-div {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  padding-top: 15px;
  height: 108px;
  margin-bottom: 25px;
}

.etc-div > h4 {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  padding-top: 15px;
  margin-top: 25px;
}

/* .etc-div > h4:before {
  content: "수동거리";
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0px 7px;
  background-color: #4881da;
  color: #fff;
  font-size: 0.7em;
} */

/* .etc-div:before {
  content: "이외거리";
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0px 7px;
  background-color: #4881da;
  color: #fff;
  font-size: 0.7em;
} */

.etc-div > ul {
  display: flex;
  justify-content: space-between;
  gap: 0.3em;
  align-items: center;
}

.etc-div > ul > li {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.2em;
}

.etc-div .etcBtn {
  width: 100%;
  height: 30px;
  border: 1px solid #fff;
  border-radius: 15px;
  color: #fff;
  background-color: transparent;
}

.etc-div .etcBtn.active {
  background-color: #fff;
  color: #4881da;
}

.etc-div .etcBtn > strong {
  font-size: 1.2em;
  font-weight: bold;
  pointer-events: none;
}

.etc-div > ul > li > select {
  font-size: 1em;
  flex: 1;
  height: 2em;
  box-sizing: border-box;
  border: 0;
  border-radius: 5px;
  margin-left: 0.5em;
  color: #000;
}

.etc-div > ul > li > span {
  font-size: 0.8em;
  color: #fff;
}

.distanceInput {
  position: relative;
  padding-top: 15px;
  margin-top: 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.distanceInput > ul {
  display: flex;
  align-items: center;
  gap: 0.2em;
}

.distanceInput > ul > li {
  color: #fff;
  font-size: 14px;
}

.distanceInput > ul > li.select {
  flex: 1;
}

.distanceInput > ul > li > select {
  font-size: 1.5em;
    padding: 0.1em 0.3em;
    width: 100%;
    height: 1.9em;
    background-color: rgba(255, 255, 255, 0.1) !important;
    color: #fff !important;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 0.5em;
}

h3 {
  font-size: 1.2em;
  color: #333;
}

p {
  font-size: 1em;
  color: #555;
  line-height: 1.4;
}

.goal-div {
  background: #fff;
  padding: 1.5em 1em 1em;
  flex: 1;
  border-radius: 0.8em;
  text-align: left;
  box-sizing: border-box;
  box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}

.goal-div > h3 {
  font-size: 1em;
  margin-bottom: 0.8em;
  font-weight: bold;
}

.goal-div > ul {
}

.goal-div > ul > li {
  font-size: 0.9em;
  display: flex;
  align-items: center;
  height: 1.9em;
}

.goal-div > ul > li > span {
  width: 4em;
  color: #555;
  font-size: 0.9em;
}

.goal-div > ul > li > strong {
  flex: 1;
}

.goal-div > ul > li > span > i,
.goal-div > ul > li > strong > i {
  font-size: 0.5em;
  color: #666;
  letter-spacing: -0.1em;
  font-style: normal;
}

.insta {
  position: fixed;
  bottom: 1em;
  right: 1em;
  text-decoration: none;
  font-size: 0.5em;
  color: #999;
  background: rgba(255, 255, 255, 0.5);
  display: block;
  padding: 0.5em;
  border-radius: 0.3em;
}

.insta::before {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
  background: url("data:image/svg+xml;base64,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")
    no-repeat;
  background-size: 100% auto;
  vertical-align: middle;
  margin: -1px 2px 0 0;
}
</style>